import React from 'react';

const MailBoxIcon = ({
  size = 18,
  color = 'currentColor',
  strokeWidth = 1.5,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22.999 18.104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      className="hover-stroke"
      d="M3.06 16.944l3.3-3.173a1.363 1.363 0 0 1 .946-.381h13.579a1.365 1.365 0 0 0 1.364-1.365V2.115a1.365 1.365 0 0 0-1.364-1.365h-18.771a1.364 1.364 0 0 0-1.364 1.365V15.961A1.364 1.364 0 0 0 3.06 16.944Z"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <line
      className="hover-stroke"
      x1="5.983"
      y1="5.521"
      x2="16.7"
      y2="5.521"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      className="hover-stroke"
      x1="5.983"
      y1="9.039"
      x2="16.7"
      y2="9.039"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MailBoxIcon;
